import React, { useContext, useState } from 'react';
import { ButtonGroup } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaGoogle, FaGithub } from "react-icons/fa";
import { AuthContext } from '../../contexts/AuthProvider/AuthProvider';
import { GithubAuthProvider, GoogleAuthProvider } from 'firebase/auth';



const Login = () => {

  const [error, setError] = useState('');
  const {logIn} = useContext(AuthContext);

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  const handleSubmit = event =>{
    event.preventDefault();
    const form = event.target;
    const email= form.email.value;
    const password= form.password.value;
    logIn(email, password)
    .then(result =>{
      const user = result.user;
      form.reset();
      setError('');
      navigate(from, {replace: true});
    })
    .catch(error => 
      {setError(error.message);
    })
  }

  const {providerLogin} = useContext(AuthContext);

  const googleProvider = new GoogleAuthProvider();

  const githubProvider = new GithubAuthProvider();

  const handleGoogleSignIn = () =>{
    providerLogin(googleProvider)
    .then(result =>{
      const user = result.user;
      
    })
    .catch(error => 
      {setError(error.message);
    })
  }

  const handleGithubSignIn = () =>{
    providerLogin(githubProvider)
    .then(result =>{
      const user = result.user;
      
    })
    .catch(error => 
      {setError(error.message);
    })
  }

    return (
        <Form onSubmit={handleSubmit} className='w-sm-50 bg-primary bg-gradient bg-opacity-50 text-dark w-50 my-5 mx-auto border border-dark rounded-2 p-3'>
          <h2>Log In</h2>
      <Form.Group className="mb-3" controlId="formBasicEmail">
        <Form.Label>Email address</Form.Label>
        <Form.Control type="email"
        name="email" placeholder="Enter email" required/>
      </Form.Group>

      <Form.Group className="mb-3" controlId="formBasicPassword">
        <Form.Label>Password</Form.Label>
        <Form.Control type="password" name="password" placeholder="Password" required/>
      </Form.Group>
      <Button variant="primary" type="submit">
        Submit
      </Button>
      <h6 className='mt-2'>Do not have an account? <Link to={'/register'}>Register here</Link></h6>
      <ButtonGroup vertical>
      <Button onClick={handleGoogleSignIn} variant="outline-primary" className='mb-2'><FaGoogle></FaGoogle> Log In with Google
      </Button>
      <Button onClick={handleGithubSignIn}  variant="outline-primary" ><FaGithub></FaGithub> Log In with Github
      </Button>
      <Form.Text className='text-danger'>Error : {error.slice(22,-2)}</Form.Text>
      </ButtonGroup>
      
    </Form>
    );
};

export default Login;